import React from "react";
import "../../css/InfoSection.css";
import { FaBrain, FaChartLine, FaKey, FaChartBar } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function InfoSection() {
  const navigate = useNavigate();

  return (
    <div className="info-container">

      {/* MAIN SECTION */}
      <div className="info-grid">

        {/* LEFT */}
        <div className="info-text">
          <h2>Why Choose FrothTestops</h2>

          <p>
           With the help of intelligent tools, seamless integrations, and real-time collaboration, FrothTestops is the system that makes your work in testing easy. Provide your QA teams with a platform that is all about speed, visibility, and control not only during the testing lifecycle but across the entire cycle. As a <span className="highlight">Best AI testing tool</span>, it facilitates planning, expedites execution, and enhances bug tracking—without adding any complexity.
          </p>
        </div>

        {/* RIGHT */}
        <div className="info-cards">

          <div className="card">
            <FaBrain className="icon" />
            <h4>AI-Powered Suggestions</h4>
            <p>
              Use smart suggestions to quickly make tests and, at the same time, be able to detect issues in advance.
            </p>
          </div>

          <div className="card card-down">
            <FaChartLine className="icon" />
            <h4>Real-Time Analytics</h4>
            <p>
              Detailed dashboards, execution trends, and test coverage metrics provide actionable insights.
            </p>
          </div>

          <div className="card">
            <FaKey className="icon" />
            <h4>Secure Collaboration</h4>
            <p>
              Team members can share test progress securely with role-based access control.
            </p>
          </div>

          <div className="card card-down">
            <FaChartBar className="icon" />
            <h4>Scalable Reporting</h4>
            <p>
              Export detailed, multi-cycle test reports from any environment in one click.
            </p>
          </div>

        </div>
      </div>

      {/* CTA SECTION */}
      {/* <div className="cta-section">
        <div className="cta-content">

          <div>
            <h3>Need to experience about FrothtestOps</h3>
            <p>Start Free Trial without credit card</p>
          </div>

          <button
            className="cta-btn"
            onClick={() => navigate("/freemium")}
          >
            Try It For Free
          </button>

        </div>
      </div> */}

    </div>
  );
}

export default InfoSection;